/**
 * 样式样条曲线选择状态 Store。
 * 统一管理样式样条曲线选中状态与样式样条曲线变化事件。
 */

import { defineStore } from 'pinia';
import { EntityInteractionEventType } from '@puppycad/cad-core';
import { BehaviorSubject, type Observable, type Subscription } from 'rxjs';
import { useViewer } from '../useViewer';
import {
  observeViewerEntityInteraction,
  resolveViewerPrimarySelectedObject,
} from './viewer-selection-helpers';

//------ 样式样条曲线选择状态 开始------
/**
 * 获取当前主选中的草图样式样条曲线对象，并观测样式样条曲线变化事件。
 */
export const useGetSelectStyleSpline = defineStore('get-select-style-spline', () => {
  let selectedStyleSpline: any | null = null;
  let subscriptions: Subscription[] = [];
  let hasSubscribed = false;
  const styleSplineChanged$ = new BehaviorSubject<any | null>(null);
  const { getViewer } = useViewer();

  

  /**
   * 从实体选择管理器同步当前选中样式样条曲线。
   */
  function syncFromManager(): void {
    selectedStyleSpline = resolveViewerPrimarySelectedObject(getViewer());
    styleSplineChanged$.next(selectedStyleSpline);
  }

  /**
   * 处理样式样条曲线选中事件。
   */
  function handleStyleSplineSelected(): void {
    syncFromManager();
  }

  /**
   * 处理选择清空事件。
   */
  function handleSelectionCleared(): void {
    selectedStyleSpline = null;
    styleSplineChanged$.next(null);
  }

  /**
   * 显式开始监听样式样条曲线选择事件。
   */
  function subscribe(): void {
    const viewer = getViewer();
    const styleSplineSelected$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.StyleSplineSelected);
    const selectionCleared$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.SelectionCleared);
    if (!styleSplineSelected$ || !selectionCleared$ || hasSubscribed) {
      return;
    }
    syncFromManager();
    subscriptions = [
      styleSplineSelected$.subscribe(handleStyleSplineSelected),
      selectionCleared$.subscribe(handleSelectionCleared),
    ];
    hasSubscribed = true;
  }

  /**
   * 取消样式样条曲线选择事件监听。
   */
  function unsubscribe(): void {
    subscriptions.forEach((subscription) => subscription.unsubscribe());
    subscriptions = [];
    hasSubscribed = false;
  }

  return {
    getSelected: (): any | null => selectedStyleSpline,
    onChanged: (): Observable<any | null> => styleSplineChanged$.asObservable(),
    subscribe,
    unsubscribe,
  };
});
//------ 样式样条曲线选择状态 结束------
